import type { BaseUsecase } from '@usecases/base-usecase';
import type { TagRepository } from '@infra/repositories/tag.repository';
import type { ApplyTagsOutput } from './apply-tags.controller';

export type ApplyTagsRequest = {
  callId: string;
  tagIds: number[];
};

export interface ApplyTagsEventPublisher {
  publish(callId: string, tagIds: number[]): Promise<void>;
}

export interface ApplyTagsUsecase
  extends BaseUsecase<ApplyTagsRequest, ApplyTagsOutput> {
  run(request: ApplyTagsRequest): Promise<ApplyTagsOutput>;
}

/**
 * Applies the agent's selected tags to the call via the DIALER.SET_TAGS bus
 * event (the full tag set in one event), then records the selection in the tag
 * repository so the mandatory-tagging gate can see the call has been tagged.
 */
export class ApplyTags implements ApplyTagsUsecase {
  constructor(
    private publisher: ApplyTagsEventPublisher,
    private tagRepository: TagRepository,
  ) {}

  async run(request: ApplyTagsRequest): Promise<ApplyTagsOutput> {
    const { callId, tagIds } = request;

    await this.publisher.publish(callId, tagIds);

    this.tagRepository.setAppliedTags(callId, tagIds);

    return { success: true };
  }
}
